import IconNameEnum from "constants/IconNameEnum";
import RouteEnum from "constants/RouteEnum";
import environment from "environment";
import IAction from "models/IAction";
import React from "react";
import { connect, DispatchProp } from "react-redux";
import ErrorAction from "stores/error/ErrorAction";
import IErrorState from "stores/error/models/IErrorState";
import ExternalAuthenticateRequestModel from "stores/utente/models/ExternalAuthenticateRequestModel";
import ExternalInfoModel from "stores/utente/models/ExternalInfoModel";
import UtenteAction from "stores/utente/UtenteAction";
import NavigationUtility from "utilities/NavigationUtility";
import IStore from "../../../models/IStore";
import { ReduxProps } from "../../../models/ReduxProps";
import BaseModal from "../base-content/BaseModal";
import BaseButton from "../base-form/BaseButton";
import BaseLabel from "../base-form/BaseLabel";

interface IProps {}

interface IState {
    showDetails: boolean;
}
interface IStateToProps {
    readonly errors: IErrorState;
    readonly hasErrors: boolean;
    readonly hasDetails: boolean;
    readonly showUserUnauthorizedAlert: boolean;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    errors: state.error,
    hasErrors: checkIfHasErrors(state.error),
    hasDetails: checkIfHasDetails(state.error),
    showUserUnauthorizedAlert: checkIfLoginRequiredOrUnauthorized(
        state.utente.profilo.isLoginRequired,
        state.utente.profilo.isLogged,
        state.error
    ),
});

const checkIfHasErrors = (errors: IErrorState) => {
    return Object.keys(errors).length > 0;
};

const checkIfHasDetails = (errors: IErrorState) => {
    let result = false;
    Object.keys(errors).forEach((error) => {
        const errorObj = errors[error].raw?.data;
        if (errorObj && (errorObj.detail || errorObj.additionalErrors)) {
            result = true;
        }
    });
    return result;
};

const checkIfUnauthorized = (errors: IErrorState) => {
    let result = false;
    Object.keys(errors).forEach((error) => {
        const errorObj = errors[error].raw?.data;
        const errorObjRaw = errors[error].raw;
        if ((errorObj && parseInt(errorObj.status) === 401) || (errorObjRaw && parseInt(errorObjRaw.status) === 401)) {
            result = true;
        }
    });
    return result;
};

const checkIfLoginRequiredOrUnauthorized = (isLoginRequired: boolean, isLogged: boolean, errors: IErrorState) => {
    if (isLoginRequired === true && isLogged === false) {
        return true;
    } else {
        return checkIfUnauthorized(errors);
    }
};

const showErrorDetail = (errorObj: any) => (
    <>
        {errorObj?.detail ? <label>{errorObj?.detail}</label> : null}
        {errorObj?.additionalErrors ? (
            <ul>
                {errorObj?.additionalErrors.map(function (item: any, i: number) {
                    // return <li key={i}>{item?.code ? i18n.t("GLOBAL_SERVER_ERROR_") + item?.code : ""}</li>;
                    if (i === 0) {
                        return <li key={i}>{item?.title || ""}</li>;
                    }
                })}
            </ul>
        ) : null}
    </>
);

class ErrorViewer extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & ReduxProps<any>) {
        super(props);
        this.state = {
            showDetails: false,
        } as IState;
    }

    private hasUnmounted = false;

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private setShowDetails = (showDetails: boolean) => {
        if (this.hasUnmounted === false) {
            this.setState({ ...this.state, showDetails });
        }
    };

    private toggleShowDetails = () => {
        this.setShowDetails(!this.state.showDetails);
    };

    private close = () => {
        // alla chiusura dell'overlay di errore vengono eliminati tutti gli errori dallo state
        this.props.dispatch(ErrorAction.clearAll());
        let matricola = sessionStorage.getItem("member");
        const abi: string = "31934";
        // console.log("ErrorViewer member", member);
        // console.log("ErrorViewer abi", abi);
        // const matricola: string = "79999";
        // const abi: string = "31934";

        const request = new ExternalAuthenticateRequestModel({
            //username: "durantel",
            //password: "durantel",
            member: Number(matricola),
            abi: abi,
            name: "luca",
            lastName: "durante",
            email: "luca.durante@linksmt.it",
            tokenCse: "noTokenCse",
        });
        if (this.props.showUserUnauthorizedAlert === true) {
            this.props.dispatch(UtenteAction.utenteLogoutGet());
            this.props.dispatch(UtenteAction.externalAuthenticate(request));
            this.props.dispatch(
                UtenteAction.setExternalInfo(
                    new ExternalInfoModel({
                        member: Number(matricola),
                        abi: abi,
                    })
                )
            );
            // NavigationUtility.redirectToPage(`/`);

            // if (member && abi) {
            //     NavigationUtility.redirectToPage(`/?matricola=${member}&abi=${abi}`);
            // } else {
            //     NavigationUtility.redirectToPage(`/`);
            // }
        }
    };

    public render(): JSX.Element {
        const { errors, hasErrors, hasDetails, showUserUnauthorizedAlert } = this.props;
        const { showDetails } = this.state;

        const list = Object.keys(errors).map(function (key) {
            const errorObj = errors[key].raw?.data;
            return errorObj;
        });

        return (
            <div>
                {environment.isDevelopment === true && (
                    <BaseModal
                        show={showUserUnauthorizedAlert}
                        onHideHandler={this.close}
                        closeOnOutClick={false}
                        centered={true}
                        className="modal-danger"
                        title={
                            <BaseLabel
                                icon={IconNameEnum.AlertRosso}
                                label="Sessione scaduta"
                                labelClassName="text-danger"
                            />
                        }
                        body="La sessione è scaduta! E' necessario effettuare nuovamente l'accesso"
                        footer={
                            <BaseButton
                                type="button"
                                color="blue"
                                label={"Rieffettua l'accesso"}
                                onClickHandler={this.close}
                            />
                        }
                    />
                )}
                {environment.isDevelopment === false && (
                    <BaseModal
                        show={showUserUnauthorizedAlert}
                        onHideHandler={this.close}
                        closeOnOutClick={false}
                        centered={true}
                        className="modal-danger"
                        title={
                            <BaseLabel
                                icon={IconNameEnum.AlertRosso}
                                label="Sessione scaduta"
                                labelClassName="text-danger"
                            />
                        }
                        body="La sessione è scaduta! E' necessario effettuare nuovamente l'accesso"
                    />
                )}
                <BaseModal
                    show={hasErrors && showUserUnauthorizedAlert === false}
                    onHideHandler={this.close}
                    closeOnOutClick={false}
                    centered={true}
                    className="modal-danger"
                    title={
                        <BaseLabel
                            icon={IconNameEnum.AlertRosso}
                            label="Si è verificato un errore"
                            labelClassName="text-danger"
                        />
                    }
                    // body={
                    //     <Row>
                    //         <Col>
                    //             {Object.keys(errors).map(function (key) {
                    //                 const errorObj = errors[key].raw?.data;
                    //                 return (
                    //                     <div key={key}>
                    //                         <label>
                    //                             {/* {i18n.t("GLOBAL_SERVER_ERROR_") + (errorObj?.code ?? "GENERIC")} */}
                    //                             {
                    //                                 "Si è verificato un errore. Riprovare o contattare l`amministratore di sistema."
                    //                             }
                    //                         </label>
                    //                         {showDetails ? <div>{showErrorDetail(errorObj)}</div> : null}
                    //                     </div>
                    //                 );
                    //             })}
                    //         </Col>
                    //     </Row>
                    // }
                    body={
                        <div>
                            {list.length > 0 ? (
                                list.map((item: any, index) => {
                                    let message = "";
                                    if (item) {
                                        if (item.detail && item.detail !== "") {
                                            message = item.detail;
                                        } else if (item.title && item.title !== "") {
                                            message = item.title;
                                        } else {
                                            message =
                                                "Si è verificato un errore. Riprovare o contattare l`amministratore di sistema.";
                                        }
                                    }
                                    return <label key={index}>{message}</label>;
                                })
                            ) : (
                                <label>
                                    Si è verificato un errore. Riprovare o contattare l`amministratore di sistema.
                                </label>
                            )}
                        </div>
                    }
                    footer={
                        <>
                            {/* {hasDetails ? (
                                <BaseButton
                                    type="button"
                                    color="grey"
                                    label={!showDetails ? "Mostra Dettagli" : "Nascondi Settagli"}
                                    icon={!showDetails ? IconNameEnum.Mostra : IconNameEnum.Nascondi}
                                    onClickHandler={this.toggleShowDetails}
                                />
                            ) : null} */}
                            <BaseButton
                                type="button"
                                color="red"
                                label={"Chiudi"}
                                icon={IconNameEnum.Ok}
                                onClickHandler={this.close}
                            />
                        </>
                    }
                />
            </div>
        );
    }
}

export { ErrorViewer as Unconnected };
export default connect(mapStateToProps)(ErrorViewer);
